'use client'
import { ContentAssetType, ContentAssetVariant } from 'codegen/types'
import Image from 'next/image'
import { useTranslations } from 'next-intl'

import { NEXT_PUBLIC_CONTENT_IMAGES_ROOT_URL } from '@web/utils/env'
import { useProductDataQuery } from '@web/hooks/use-product-data'
import { useWasDownloadedState } from '@web/app/[locale]/(web)/prod/[slug]/product-asset-context'

export function JustDowloaded() {
  const t = useTranslations('prod.product_description_page.suggestions.banner')
  const [showSuggestions, setShowSuggestions] = useWasDownloadedState()
  const { data: productContent } = useProductDataQuery()
  const thumbnail = productContent?.publicAssets
    .filter(asset => asset.type === ContentAssetType.AssetTypeThumbnail)
    .find(
      asset =>
        asset.variant === ContentAssetVariant.AssetVariantXsmall ||
        asset.variant === ContentAssetVariant.AssetVariantSmall,
    )
  const imageProps = {
    src: `${NEXT_PUBLIC_CONTENT_IMAGES_ROOT_URL}/${thumbnail?.file_path}`,
    width: thumbnail?.resolution?.width ?? 300,
    height: thumbnail?.resolution?.height ?? 300,
    alt: `${productContent?.title || 'preview image'} thumbnail`,
    title: productContent?.title ? `${productContent.title}` : '',
  }

  if (!showSuggestions) {
    return null
  }

  return (
    <div className="rounded-2 col-start-1 flex h-[68px] w-full flex-row items-center justify-between gap-2 border border-[#DFDDE5] p-2 min-[960px]:gap-4">
      {thumbnail ? (
        <Image
          {...imageProps}
          alt={'Product image preview'}
          className="rounded-2 h-full w-auto max-w-[33%] shrink-0 grow-0 object-contain"
          unoptimized
        />
      ) : null}
      <div className="grow">{t('label')}</div>
      <button
        onClick={() => {
          setShowSuggestions(false)
        }}
        className="text-cf-link"
      >
        <span className="hidden min-[575px]:inline">{t('cta')}</span>
        <span className="min-[575px]:hidden">{t('cta_short')}</span>
      </button>
    </div>
  )
}
